// import { WidgetPicker } from './WidgetPicker';
import React from 'react';
import WidgetPicker from '../components/WidgetPicker';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import qs from 'qs';

const WidgetPickerPage = compose(
    connect(
        (state, { params }) => {
            const query = qs.parse(window.location.search, {
                ignoreQueryPrefix: true,
                decoder: value => {
                    value = decodeURIComponent(value);
                    try {
                        value = JSON.parse(value);
                    } catch (e) {
                        //
                    }
                    return value;
                },
            });

            // prepare required params for WidgetPicker from url

            return {
                tab: params.tab,
                params: query,
                template: query.template,
            };
        },
        () => ({
            onWidgetSelected: (e, widget) => {
                const { query } = browserHistory.getCurrentLocation();
                const { pathname } = window.location;

                const urlFriendlyParams = _.chain(widget.props || {})
                    .toPairs()
                    .map(([k, v]) => {
                        let out = null;
                        if (v === '' || v === null || v === 'undefined' || _.isUndefined(v)) out = null;
                        if (_.isObject(v)) {
                            out = JSON.stringify(v);
                        } else {
                            out = v;
                        }
                        console.log('>', k, v, out);
                        return [k, out];
                    })
                    .fromPairs()
                    // .compact()
                    .value();

                browserHistory.push({
                    pathname: `/editor/${widget.id}/layout`,
                    query: { ...urlFriendlyParams, template: query.template } || {},
                });
            },
            onTemplateChanged: template => {
                const { query } = browserHistory.getCurrentLocation();
                const { pathname } = window.location;
                browserHistory.push({
                    pathname,
                    query: _.omit({ ...query, template }),
                });
            },
            onTabOpen: (tab, params) => {
                const { query } = browserHistory.getCurrentLocation();
                browserHistory.push({
                    pathname: `/editor/pick/${tab}`,
                    query: _.omit({ ...params, template: query.template }),
                });
            },
        }),
    ),
    lifecycle({
        componentWillReceiveProps() {},
        componentDidMount() {},
    }),
)(WidgetPicker);

export default WidgetPickerPage;



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/containers/WidgetPickerPage.js
 **/